import { createSelector } from 'reselect'
import { State } from 'interfaces/state'

export const cropperAppStateSelector = (state: State) => state.app.cropper

export const cropperInputSelector = createSelector(
  cropperAppStateSelector,
  ({ inputFile }) => inputFile
)

export const cropperOutputSelector = createSelector(
  cropperAppStateSelector,
  ({ outputFile }) => outputFile
)
